import React from "react";

export default function GeneralSettings() {
  return <div>GeneralSettings</div>;
}
